import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk} from '../createStore';
import {RootState} from '../rootReducer';

export type UserFeedbackType = 'error' | 'success' | 'app-outdated';

export type UserFeedbackState = {
  isShown: boolean;
  message: string;
  type?: UserFeedbackType;
};

const initialState: UserFeedbackState = {
  isShown: false,
  message: '',
  type: undefined,
};

const slice = createSlice({
  name: 'view/userFeedback',
  initialState: initialState,
  reducers: {
    feedbackShown: (state, action: PayloadAction<{message: string; type: UserFeedbackType; timerId?: number}>) => {
      const {message, type} = action.payload;
      state.message = message;
      state.type = type;
      state.isShown = true;
    },
    feedbackHidden: (state) => {
      state.isShown = false;
      state.message = '';
      state.type = undefined;
    },
  },
  extraReducers: () => {},
});

const {feedbackShown, feedbackHidden} = slice.actions;
export const userFeedbackReducer = slice.reducer;

let timer: ReturnType<typeof setTimeout>;

export const showTimedFeedback =
  ({message, type, timeout}: {message: string; type: UserFeedbackType; timeout?: number}): AppThunk =>
  (dispatch) => {
    const messageTimeout = timeout ?? 3000;

    // app-outdated feedback will never hide
    if (type !== 'app-outdated') {
      timer = setTimeout(() => {
        dispatch(feedbackHidden());
      }, messageTimeout);
    }

    dispatch(feedbackShown({message, type}));
  };

export const hideTimedFeedback = (): AppThunk => (dispatch) => {
  if (timer) {
    clearTimeout(timer);
  }
  dispatch(feedbackHidden());
};

export const getIsUserFeedbackShown = (state: RootState) => state.ui.userFeedback.isShown;

export const getUserFeedbackMessage = (state: RootState) => state.ui.userFeedback.message;

export const getUserFeedbackType = (state: RootState) => state.ui.userFeedback.type;
